import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import backgroundImage from './static/images/jacek-dylag-hUHzaiAHuUc-unsplash.jpg';

declare module '@mui/material/styles' {
  interface Palette {
    blue?: {
      light: string;
      main: string;
      lightTransparent: string;
    };
    white?: { light: string };
  }
  interface PaletteOptions {
    blue?: {
      light: string;
      main: string;
      lightTransparent: string;
    };
    white?: { light: string };
  }
}

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#80ade6',
      main: '#2c76d5',
      dark: '#1d5195',
    },
    blue: {
      light: '#80ade6',
      main: '#2c76d5',
      lightTransparent: '#80ade62b',
    },
    white: { light: '#ffffff' },
  },
  typography: {
    fontFamily: 'var(--tms-sans)',
    h1: { fontFamily: 'Lobster, cursive', fontWeight: 400 },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          minHeight: 40,
          borderRadius: 10,
          paddingInline: 16,
          fontWeight: 600,
          lineHeight: 1.25,
          textTransform: 'none',
        },
        sizeSmall: {
          minHeight: 32,
          paddingInline: 12,
        },
        sizeLarge: {
          minHeight: 48,
          paddingInline: 24,
        },
        outlined: {
          borderWidth: 1,
          '&:hover': {
            borderWidth: 1,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          color: '#3b3b3b',
          fontFamily: 'var(--tms-sans)',
          backgroundColor: 'black',
          background:
            `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundAttachment: 'fixed',
          margin: 0,
        },
      },
    },
  },
});

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          html: { height: 'auto !important', overflow: 'visible !important' },
          body: { height: 'auto !important', overflow: 'visible !important' },
          '#root': { height: 'auto !important', overflow: 'visible !important' },
        }}
      />
      {children}
    </ThemeProvider>
  );
};

